var _ = require('underscore');
var TorsoCollection = require('backbone-torso/modules/Collection');
var appointmentTypeExtService = require('./../urls').appointmentTypeExtService;
var AppointmentTypeModel = require('./AppointmentTypeModel');
var partialListUtils = require('./../utils/partialListUtils');

/**
 * @class AppointmentTypeCollection
 * @extends Torso.Collection
 */
module.exports = new (TorsoCollection.extend({
  model: AppointmentTypeModel,
  url: appointmentTypeExtService,

  comparator: function(model) {
    return model.get('displayName');
  },

  /**
   * Fetch a list of AppointmentType IDs by criteria
   * @method fetchIdsByCriteria
   * @param criteria {Object} criteria suitable for the appointmentTypeExtService
   * @return A Promise wrapping a list of ids
   */
  fetchIdsByCriteria: function(criteria) {
    return this.fetchPartialListByCriteria(criteria)
        .then(partialListUtils.convertPartialListResponseToList);
  },

  /**
   * Fetch a partial list object from appointment microservice by criteria
   * @method fetchPartialListByCriteria
   * @param criteria {Object} criteria suitable for the appointmentTypeExtService
   * @returns A Promise of an ajax request to get partial list object by criteria
   */
  fetchPartialListByCriteria: function(criteria) {
    if (!_.isObject(criteria)) {
      throw 'Criteria should be an object with properties defined by AppointmentTypeCriteria.java';
    }
    return $.ajax({
      url: appointmentTypeExtService + '/criteria',
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(criteria)
    });
  }
}))();
